import { Link, useNavigate } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';
import { useEffect, useState } from 'react';
import useAuth from '../../../hooks/useAuth';
import Alert, { ALERT_TYPE } from '../../../components/alert/Alert';
import useAlert from '../../../hooks/useAlert';

const LoginPage = () => {
  const [email, setEmail] = useState('demouser@test.com');
  const [password, setPassword] = useState('demoPass123');
  const { alertType, alertHeader, alertDescription, displayAlert, resetAlert } =
    useAlert();

  const navigate = useNavigate();
  const { user, isAuthenticated, isLoading, login } = useAuth();

  const onLoginClicked = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // validation
    resetAlert();
    try {
      await login(email, password);
      navigate(ROUTES.DASHBOARD_PAGE);
    } catch (error) {
      displayAlert(ALERT_TYPE.ERROR, 'Login Failed!', `${error}`);
    }
  };

  useEffect(() => {
    if (!isLoading && isAuthenticated && user) {
      navigate(ROUTES.DASHBOARD_PAGE);
    }
    resetAlert();
  }, [resetAlert, user, isAuthenticated, isLoading, navigate]);

  return (
    <>
      <div className="flex min-h-full flex-1 items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
        <div className="w-full max-w-sm space-y-10">
          <div>
            <img
              className="mx-auto h-32 w-auto"
              src="/logo512.png"
              alt="Trade-Tracker"
            />
            <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
              Sign in to your account
            </h2>
          </div>

          <form className="space-y-4" onSubmit={onLoginClicked}>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Email Address
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  autoComplete="email"
                  required
                  className="block w-full rounded-md border-0 px-3.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Password
              </label>

              <div className="mt-2">
                <input
                  id="password"
                  name="password"
                  type="password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  autoComplete="current-password"
                  required
                  className="block w-full rounded-md border-0 px-3.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <input
                  id="remember-me"
                  name="remember-me"
                  type="checkbox"
                  className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                />
                <label
                  htmlFor="remember-me"
                  className="ml-3 block text-sm leading-6 text-gray-900"
                >
                  Remember me
                </label>
              </div>

              <div className="text-sm leading-6">
                <Link
                  to={ROUTES.FORGET_PASSWORD}
                  className="font-semibold text-indigo-600 hover:text-indigo-500"
                >
                  Forgot password?
                </Link>
              </div>
            </div>

            {alertType && (
              <Alert
                alertType={alertType}
                alertHeader={alertHeader ?? ''}
                alertDescription={alertDescription ?? ''}
              />
            )}

            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Sign in
              </button>
            </div>
          </form>

          <p className="text-center text-sm leading-6 text-gray-500">
            Not a member?{' '}
            <Link
              to={ROUTES.SIGN_UP}
              className="font-semibold text-indigo-600 hover:text-indigo-500"
            >
              Sign up now
            </Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
